import type { ApiClient } from "../../app/api/client";
import { previewSystemDocument, previewSystemDocumentPdf, sendSystemDocument, type SystemDocumentPreviewDto, type SystemDocumentSendRequest } from "../../pages/settings/systemDocuments/systemDocumentApi";
import type { SendDocumentReviewRequest } from "../communication/SendDocumentReviewWorkspace";

/** Der Formularentwurf bleibt lokal. Nach bestätigtem Speichern wiederholt ein Versandversuch nur den Versand. */
export function deferredContractDocumentReview(options: {
  api: ApiClient;
  review: Pick<SendDocumentReviewRequest, "kind" | "referenceId" | "variantId" | "sendEmail" | "title">;
  previewUrl: string;
  previewBody: (document: Parameters<NonNullable<SendDocumentReviewRequest["preview"]>>[0]) => unknown;
  save: () => Promise<string>;
  onReturn: () => void;
  onComplete: () => void;
  onSent: SendDocumentReviewRequest["onSent"];
}): SendDocumentReviewRequest {
  let savedReferenceId: string | null = null;
  let saving: Promise<string> | null = null;
  return {
    ...options.review,
    preview: request => savedReferenceId
      ? previewSystemDocument(options.api, options.review.kind, { ...request, referenceId: savedReferenceId })
      : options.api.post<SystemDocumentPreviewDto>(options.previewUrl, options.previewBody(request)),
    previewPdf: request => savedReferenceId
      ? previewSystemDocumentPdf(options.api, options.review.kind, { ...request, referenceId: savedReferenceId })
      : options.api.blob(`${options.previewUrl}${options.previewUrl.includes("?") ? "&" : "?"}pdf=true`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(options.previewBody(request)),
    }),
    send: async (request: SystemDocumentSendRequest) => {
      if (!savedReferenceId) {
        saving ??= options.save().catch(error => { saving = null; throw error; });
        savedReferenceId = await saving;
      }
      return sendSystemDocument(options.api, options.review.kind, { ...request, referenceId: savedReferenceId });
    },
    onCancel: () => savedReferenceId ? options.onComplete() : options.onReturn(),
    onSent: result => { options.onSent(result); options.onComplete(); },
  };
}
